import { render, staticRenderFns } from "./VitalSigns.vue?vue&type=template&id=2818dd24&scoped=true"
import script from "./VitalSigns.vue?vue&type=script&lang=js"
export * from "./VitalSigns.vue?vue&type=script&lang=js"
import style0 from "./VitalSigns.vue?vue&type=style&index=0&id=2818dd24&prod&scoped=true&lang=css"
import style1 from "./VitalSigns.vue?vue&type=style&index=1&id=2818dd24&prod&lang=css"
import style2 from "./VitalSigns.vue?vue&type=style&index=2&id=2818dd24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818dd24",
  null
  
)

export default component.exports